export default {
  SET_MODELOS(state, payload) {
    state.modeloRelatorio = payload;
  },
  SET_MODELO(state, payload) {
    state.selectedModelo = payload;
  },
  SET_COLUNAS_DINAMICAS(state, payload) {
    state.colunasDinamicasModelo = payload;
  },
  LIMPAR_COLUNAS(state) {
    state.colunasDinamicasModelo = [];
  },
  SET_FILTRO_MODELO(state, payload) {
    state.filtroModelo = payload;
  },
};
